import React from 'react';
import { FaWallet, FaCoins, FaPlusCircle, FaSyncAlt, FaShareSquare } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function AdminVirtualSupplyCards({ virtualBalances, loading, onRefresh, onOpenAssign }) {
    const parseBal = (val) => {
        const num = parseFloat(val);
        return isNaN(num) ? 0 : num;
    };

    const formatCurrency = (val) => {
        return Number(parseBal(val)).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const cards = [
        {
            id: 'main_wallet',
            title: 'Admin Virtual Main Wallet',
            badge: 'Main Pool (MB)',
            balance: virtualBalances?.main_wallet ?? 0,
            loadUrl: '/admin/wallet/add/virtual-wallet?wallet=main_wallet',
            cardGradient: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
            badgeBg: '#dbeafe',
            badgeColor: '#1e40af',
            desc: 'Used for Retailer Main Wallet top-up requests',
        },
        {
            id: 'aeps_wallet',
            title: 'Admin Virtual AEPS Wallet',
            badge: 'AEPS Pool (AW)',
            balance: virtualBalances?.aeps_wallet ?? 0,
            loadUrl: '/admin/wallet/add/virtual-wallet?wallet=aeps_wallet',
            cardGradient: 'linear-gradient(135deg, #6b21a8 0%, #a855f7 100%)',
            badgeBg: '#f3e8ff',
            badgeColor: '#6b21a8',
            desc: 'Used for Retailer AEPS balance disbursement',
        },
        {
            id: 'cashback_wallet',
            title: 'Admin Virtual Cashback Wallet',
            badge: 'Cashback Pool (CW)',
            balance: virtualBalances?.cashback_wallet ?? 0,
            loadUrl: '/admin/wallet/add/virtual-wallet?wallet=cashback_wallet',
            cardGradient: 'linear-gradient(135deg, #c2410c 0%, #f97316 100%)',
            badgeBg: '#ffedd5',
            badgeColor: '#c2410c',
            desc: 'Used for Retailer Cashback & bonus disbursements',
        },
    ];

    return (
        <div className="container-fluid px-4 pt-3 pb-2">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h4 className="fw-bold mb-1" style={{ color: '#1e293b' }}>
                        <FaCoins className="me-2 text-primary" />
                        Live Admin Virtual Supply Balances
                    </h4>
                    <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>
                        Current available virtual digits to disburse retailer requests. Load anytime with instant audit logging.
                    </p>
                </div>
                <div className="d-flex gap-2">
                    {onRefresh && (
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm rounded-pill px-3"
                            onClick={onRefresh}
                            disabled={loading}
                        >
                            <FaSyncAlt className={`me-1 ${loading ? 'fa-spin' : ''}`} /> Refresh
                        </button>
                    )}
                    <Link
                        to="/admin/wallet/add/virtual-wallet"
                        className="btn btn-primary btn-sm rounded-pill px-3 fw-bold shadow-sm"
                    >
                        <FaPlusCircle className="me-1" /> + Load Virtual Money
                    </Link>
                </div>
            </div>

            <div className="row g-3 mb-2">
                {cards.map((c) => {
                    const balNum = parseBal(c.balance);
                    const isNegative = balNum < 0;

                    return (
                        <div className="col-xl-4 col-md-6" key={c.id}>
                            <div
                                className="p-3 shadow-sm rounded-3 text-white h-100 d-flex flex-column justify-content-between"
                                style={{
                                    background: c.cardGradient,
                                    minHeight: '130px',
                                    height: '130px',
                                    transition: 'transform 0.2s ease',
                                }}
                            >
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div
                                        style={{
                                            backgroundColor: 'rgba(255,255,255,0.2)',
                                            borderRadius: '50%',
                                            width: '38px',
                                            height: '38px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <FaWallet className="text-white fs-5" />
                                    </div>
                                    <span
                                        className="badge fw-bold"
                                        style={{
                                            backgroundColor: c.badgeBg,
                                            color: c.badgeColor,
                                            fontSize: '0.75rem',
                                            padding: '4px 10px',
                                        }}
                                    >
                                        {c.badge}
                                    </span>
                                </div>

                                <div className="d-flex justify-content-between align-items-end mt-auto">
                                    <div>
                                        <div
                                            className="fw-bold mb-0 text-white"
                                            style={{
                                                fontSize: '1.65rem',
                                                letterSpacing: '0.3px',
                                                textShadow: '0 2px 4px rgba(0,0,0,0.25)',
                                            }}
                                        >
                                            ₹{formatCurrency(c.balance)}
                                        </div>
                                        <div
                                            className="text-white-50 mt-1"
                                            style={{ fontSize: '0.82rem', fontWeight: 500 }}
                                        >
                                            {c.title}
                                        </div>
                                    </div>

                                    <div className="d-flex gap-2">
                                        <Link
                                            to={c.loadUrl}
                                            className="btn btn-sm btn-light rounded-pill px-3 py-1 fw-bold shadow-sm"
                                            style={{
                                                fontSize: '0.78rem',
                                                color: c.badgeColor,
                                                border: 'none',
                                            }}
                                            title={`Load money into ${c.title}`}
                                        >
                                            <FaPlusCircle className="me-1" /> Load
                                        </Link>
                                        {onOpenAssign && (
                                            <button
                                                type="button"
                                                className="btn btn-sm rounded-pill px-3 py-1 fw-bold shadow-sm"
                                                style={{
                                                    fontSize: '0.78rem',
                                                    backgroundColor: 'rgba(255, 255, 255, 0.22)',
                                                    color: '#ffffff',
                                                    border: '1px solid rgba(255, 255, 255, 0.45)',
                                                    backdropFilter: 'blur(4px)',
                                                }}
                                                onClick={() => onOpenAssign(c)}
                                                title={`Directly assign money from ${c.badge} to any User`}
                                            >
                                                <FaShareSquare className="me-1" /> Assign
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default AdminVirtualSupplyCards;
